/**
 * Utility functions for storing and retrieving last accessed project information
 */

const LAST_PROJECT_ID_KEY = 'ampersand_last_project_id';

/**
 * Save the last accessed project ID to localStorage
 */
export const saveLastAccessedProjectId = (projectId: string): void => {
  try {
    localStorage.setItem(LAST_PROJECT_ID_KEY, projectId);
  } catch (error) {
    console.error('Failed to save last accessed project ID:', error);
  }
};

/**
 * Get the last accessed project ID from localStorage
 */
export const getLastAccessedProjectId = (): string | null => {
  try {
    return localStorage.getItem(LAST_PROJECT_ID_KEY);
  } catch (error) {
    console.error('Failed to get last accessed project ID:', error);
    return null;
  }
};

/**
 * Clear the last accessed project ID from localStorage
 */
export const clearLastAccessedProjectId = (): void => {
  try {
    localStorage.removeItem(LAST_PROJECT_ID_KEY);
  } catch (error) {
    console.error('Failed to clear last accessed project ID:', error);
  }
};
